var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveCoa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9229 10.8422H13.6448C13.3267 10.8422 13.0674 11.1015 13.0674 11.4195C13.0674 11.5815 13.1363 11.7274 13.2436 11.8327L18.3685 16.9575C18.4737 17.071 18.6258 17.142 18.792 17.142C18.9924 17.142 19.1686 17.0406 19.272 16.8867C20.5319 15.4241 21.3422 13.5666 21.4881 11.5228C21.4962 11.4884 21.5002 11.4539 21.5002 11.4195C21.5003 11.1015 21.243 10.8422 20.9229 10.8422Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4482 0.380859C11.1301 0.382804 10.8729 0.640143 10.8729 0.958154V9.04656C10.8729 9.36665 11.1301 9.62593 11.4482 9.62593H19.5386C19.8567 9.62593 20.1159 9.36665 20.1159 9.04656C19.8303 4.39171 16.1051 0.666525 11.4482 0.380859Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8929 16.4859L9.9254 10.5183C9.82415 10.415 9.76341 10.2712 9.76341 10.1152L9.76127 1.68642C9.76127 1.36841 9.50406 1.11113 9.18599 1.11113C4.33862 1.40691 0.5 5.43384 0.5 10.3543C0.5 15.469 4.64659 19.6175 9.76127 19.6175C12.0948 19.6175 14.2258 18.7546 15.8544 17.3305C15.9801 17.2251 16.0591 17.0672 16.0591 16.891C16.0591 16.735 15.9962 16.5911 15.8929 16.4859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCoa);
export default __webpack_public_path__ + "static/media/ActiveCOA.17a77ba7b700aa9e21151feec84e8a7b.svg";
export { ForwardRef as ReactComponent };